import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import LoanPaymentDebitForm from "../../components/forms/loan-payment-debit/loan-payment-debit-form.component";
import { hideHeader, processComplete, changePaymentType, toggleEditMode } from "../../actions/appStatus.actions";
import Show from "../../utils/show.component";
import SSNValidation from "./ssn-validation-form";
import { validateSSN } from "../../utils/requests";
import { getToken } from "../../actions/token.actions";
import { verifyPayment, setAppraisalChargeFee, setFeeType } from "../../actions/payment.actions";
import { showModal, hideModal } from "../../actions/modal.actions";
import ReactGA from "react-ga";

class HomeEquityAppraisalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ssnValidated: false,
      linkExpired: false,
      appraisalChargeFee: "",
      success: false,
      showError: false,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.props.hideHeader();
    ReactGA.pageview(`payments.laketrust.org${window.location.pathname}`,[],'Home Equity Appraisal');
    let editMode = this.props.match.params.guid === 'edit';
    if (this.props.token == null) {
      this.props.getToken();
    }
    if (editMode) {
      this.setState({ssnValidated: true});
    } 
  }

  // Get a new token if the app is cancelled on this page and doesn't have a token
  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token && this.props.token == null) {
      this.props.getToken();
    }
  }

  submitForm(formName) {
    window.scrollTo(0,0);
    this.setState({ showError: false });
    let details = this.props.form[formName].values;
    let guid = this.props.match.params.guid;
    this.props.showModal("loading", "Verifying SSN...");

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute("6LdVHekUAAAAAPRqzyhts0xp9pIEJP_JMFvZnqK6", { action: "appraisal" })
        .then((token) => {
          if (formName === "SSNValidation") {
            // Verify SSN
            validateSSN({ ssn: details.taxIdLast4, guid: guid, token: token }).then((res) => {
              this.props.hideModal();
              if (res.Validated === true) {
                this.props.changePaymentType("Appraisal");
                this.setState({ ssnValidated: true });
                this.props.setAppraisalChargeFee(res.Amount);
                this.props.setFeeType(res.FeeType)
              } else if (res.LinkExpired === true) {
                this.setState({ linkExpired: true});
              } else {
                this.setState({ showError: true });
              }
            });
          } else {
            this.props.hideModal();
            try {
              // Verify payment stuff goes here
              this.props.verifyPayment(details, "appraisal");
              if(this.props.appStatus.editMode){
                this.props.toggleEditMode();
              }
            } catch (error) {
              this.setState({ showError: true });
            }
          }
        });
    });
  }

  render() {
    // If we got back a payment error and it is blank, go to the next screen.
    if (this.state.linkExpired === true) {
      return <Redirect to="/link-is-no-longer-valid" />;
    }
    if (this.props.payment.PaymentError === "") {
      return <Redirect to="/loan-review" />;
    }
    return (
      <div className="container app-container" style={{ marginTop: "80px" }}>
        <h1 style={{ textAlign: "center" }}>Pay Your {this.props.payment.feeType || 'Real Estate Fee'}</h1>
        <div style={{ marginTop: "60px" }}>
          <Show condition={this.state.showError === true}>
            <div className="error-message">Failed to validate, please try again</div>
          </Show>
          <Show condition={this.state.ssnValidated === false}>
            <SSNValidation submitForm={this.submitForm} />
          </Show>
          <Show condition={this.state.ssnValidated}>
            <LoanPaymentDebitForm
              show={true}
              submitForm={this.submitForm}
              paymentType={this.props.appStatus.paymentType}
              amountDue={this.props.payment.appraisalFee}
              ChargeOffIsRequired={true}
            />
          </Show>
        </div>
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideHeader,
  processComplete,
  getToken,
  verifyPayment,
  changePaymentType,
  showModal,
  hideModal,
  toggleEditMode,
  setAppraisalChargeFee,
  setFeeType
};

//Connect to Redux store
const HomeEquityAppraisal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomeEquityAppraisalComponent)
);

export default HomeEquityAppraisal;



// WEBPACK FOOTER //
// ./src/pages/home-equity-appraisal/component.js